import { render, staticRenderFns } from "./AdminPanelDashboard.vue?vue&type=template&id=10173ae9"
import script from "./AdminPanelDashboard.vue?vue&type=script&lang=js"
export * from "./AdminPanelDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelDashboard.vue?vue&type=style&index=0&id=10173ae9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports